import "./boxListCarousel.css";
import Card from "../Card/Card";
import { useState } from "react";
import {
  getPriceDarkHoverColor,
  getPriceDarkBorderColor,
} from "../../utils/GlobalConstants";
import {
  getPriceDarkBgColor,
  getPriceLightBgColor,
} from "../../utils/HelperFunctions";
import { routes } from "../../routes";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { ChevronRightIcon } from "lucide-react";
import { useNavigate, useLocation, useParams } from "react-router";
import { ReactComponent as FireIcon } from "../../assets/icons/fireIcon.svg";
import { ReactComponent as GiftLight } from "../../assets/icons/gift_box_light.svg";

const BoxListCarousel = ({
  boxName,
  spinner,
  loading,
  hasMore,
  category,
  hideThis,
  cardData,
  WheelPage,
  showOverlay,
  observerRef,
  searchModal,
  setShowOverlay,
  setOverlayData,
  hideSearchModal,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slugId } = useParams();
  const [hoveredId, setHoveredId] = useState(null);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const shouldHide = location.pathname.includes("/unboxing/box/spin");

  const encryptData = (data) => {
    const base64EncodedData = window?.btoa(data?.toString());
    return base64EncodedData;
  };

  const handleProductClick = (product) => {
    if (location?.pathname === `${routes.BOXDETAIL}/${slugId}`) {
      setOverlayData(product);
      setShowOverlay((prevState) => !prevState);
    }
  };

  return (
    <>
      <div className={WheelPage ? "container p-0 p-lg-2 p-md-2" : ""}>
        {shouldHide && cardData?.name ? (
          <div className="d-center text-white text-36px fw-bold my-5">
            Popular Boxes
          </div>
        ) : (
          <>
            {!searchModal && (
              <div className="box-list-header">
                <div className="product-div">
                  <div className="left-section">
                    <div className="d-center">
                      {isDarkMode ? (
                        <FireIcon
                          style={{ marginRight: "16px", marginBottom: "2px" }}
                        />
                      ) : (
                        <GiftLight
                          style={{ marginRight: "16px", marginBottom: "2px" }}
                        />
                      )}
                      <span className="text-24px text-fw-700">
                        {category
                          ? category === "All"
                            ? "Latest Boxes Released"
                            : category + " Boxes"
                          : boxName}
                      </span>
                    </div>
                  </div>
                  {hideThis && (
                    <button
                      onClick={() => navigate(routes.UNBOXES)}
                      style={{ fontSize: "14px" }}
                      className="topbrands-viewall"
                    >
                      View All <ChevronRightIcon size={15} strokeWidth={2.5} />
                    </button>
                  )}
                </div>
              </div>
            )}
            {spinner ? (
              <div className="product-grid-wrapper">
                <div className="product-grid">
                  {cardData.box?.length ? (
                    cardData?.box?.map((product, index) => (
                      <div
                        key={index}
                        onClick={() => handleProductClick(product)}
                        className="product-card-outer"
                        style={{
                          background:
                            hoveredId === product.id
                              ? getPriceDarkHoverColor(product.price)
                              : getPriceDarkBgColor(product.price),
                          borderTop:
                            hoveredId === product.id
                              ? `1px solid ${getPriceDarkBorderColor(product.price)}`
                              : "1px solid transparent",
                        }}
                        onMouseEnter={() => setHoveredId(product.id)}
                        onMouseLeave={() => setHoveredId(null)}
                      >
                        {/* Percentage Tag */}
                        <div
                          className={`percentage-tag ${isDarkMode ? "dark" : "light"}`}
                          style={{
                            background: "rgba(17, 0, 0, 0.20)",
                          }}
                        >
                          {product?.percentage}%
                        </div>
                        {/* Product Image */}
                        <div className="product-image-wrapper">
                          <img
                            alt={product.name}
                            src={product.image}
                            className="product-list-image"
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/300x200?text=No+Image";
                            }}
                          />
                        </div>

                        {/* Product Name */}
                        <h6
                          className={`mb-0 text-center text-14px text-md-14px text-fw-700 ${isDarkMode ? "text-lavender-gray" : "text-charcoal-gray"}`}
                        >
                          {product.name}
                        </h6>

                        {/* Price */}
                        <div className="d-center">
                          <span
                            className={`w-100 ${
                              isDarkMode ? "box-list-btn" : "box-list-btn"
                            }`}
                          >
                            {product.formatted_price}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no-products-message">
                      <p>No products available in this box</p>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <Container className="p-0" fluid>
                {cardData && cardData.length === 0 && !loading ? (
                  <div className="d-center my-4">No boxes found.</div>
                ) : (
                  <div
                    className={`cards-grid-container ${searchModal && "p-0"}`}
                  >
                    {cardData?.map((item, index) => (
                      <Card
                        item={item}
                        index={index}
                        key={item?.id}
                        spinner={spinner}
                        type={cardData?.name}
                        searchModal={searchModal}
                        showOverlay={showOverlay}
                        setOverlayData={setOverlayData}
                        setShowOverlay={setShowOverlay}
                        hideSearchModal={hideSearchModal}
                      />
                    ))}
                  </div>
                )}
              </Container>
            )}
          </>
        )}
        {hasMore && (
          <div
            ref={observerRef}
            style={{ height: "1px", marginBottom: "40px" }}
          />
        )}
        {loading && (
          <div className="d-center w-100 my-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BoxListCarousel;
